import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import {
  Insights as InsightsIcon,
  Logs as LogsIcon,
  SettingsCog as SettingsCogIcon,
} from 'common/icons'
import {
  getContentHasVariants,
  getElementHasVariants,
  getIsOptimized,
} from 'features/unifiedFlow/contentPage/helpers'
import {
  useContent,
  useSelectedElement,
} from 'features/unifiedFlow/contentPage/hooks'

import ExportMenuButton from '../../components/layout/components/ExportMenuButton'

import { HandleActivePanelChange } from './RightSection'

type Props = {
  handleActivePanelChange: HandleActivePanelChange
}

const CollapsedIcons = ({ handleActivePanelChange }: Props) => {
  const { content } = useContent()
  const { data: selectedElement } = useSelectedElement()

  const isOptimized = getIsOptimized(selectedElement)
  const hasVariants = getContentHasVariants(content)
  const hasElementVariants = getElementHasVariants(selectedElement)

  const commonClassName = 'text-gold-600 cursor-pointer hover:text-gold-700'

  return (
    <>
      {isOptimized && hasElementVariants && (
        <ButtonWithTooltip
          data-testid="insights-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Insights"
          placement="left"
          prefixIcon={
            <InsightsIcon
              size={6}
              isDefaultColor={false}
              className={commonClassName}
            />
          }
          onClick={() => handleActivePanelChange('insights')}
        />
      )}
      {selectedElement && hasVariants && (
        <div className="flex items-stretch" style={{ height: '38px' }}>
          <ExportMenuButton tooltipPlacement="left" />
        </div>
      )}
      {isOptimized && (
        <ButtonWithTooltip
          data-testid="advanced-settings-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Advanced settings"
          placement="left"
          prefixIcon={
            <SettingsCogIcon
              size={6}
              isDefaultColor={false}
              className={commonClassName}
            />
          }
          onClick={() => handleActivePanelChange('advancedSettings')}
        />
      )}
      {isOptimized && hasElementVariants && (
        <ButtonWithTooltip
          data-testid="campaignLogs-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Logs"
          placement="left"
          prefixIcon={
            <LogsIcon
              size={6}
              isDefaultColor={false}
              className={commonClassName}
            />
          }
          onClick={() => handleActivePanelChange('campaignLogs')}
        />
      )}
    </>
  )
}

export default CollapsedIcons
